/**
 * AsideForms Class
 */
export class AsideForms {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.scene = document.querySelector( containerEl );

		this.addEvents();

	}

	/**
	 * Add Events
	 *
	 * @return {void}
	 */
	addEvents() {

		const aside = document.querySelector( '.aside-forms' );
		const buttons = document.querySelectorAll( '.aside-forms__button' );
		const tabs = document.querySelectorAll( '.aside-forms__tab' );
		const close = document.querySelectorAll( '.aside-forms__close' );
		const back = document.querySelectorAll( '.aside-forms__back' );

		if ( buttons.length > 0 ) {

			buttons.forEach( ( button ) => {

				button.addEventListener( 'click', ( e ) => {

					closeTabs();

					const index = [ ...e.currentTarget.parentElement.children ].indexOf( e.currentTarget );

					tabs[ index ].classList.add( 'is-active' );
					aside.classList.add( 'is-active' );

				} );

			} );

		}

		if ( close.length > 0 ) {

			close.forEach( ( button ) => {

				button.addEventListener( 'click', ( ) => {

					closeTabs();

				} );

			} );

		}

		if ( back.length > 0 ) {

			back.forEach( ( button ) => {

				button.addEventListener( 'click', ( ) => {

					closeTabs();

				} );

			} );

		}

		/**
		 * Close Tabs
		 *
		 * @return {void}
		 */
		const closeTabs = () => {

			if ( tabs.length > 0 ) {

				tabs.forEach( ( tabClosed ) => {

					tabClosed.classList.remove( 'is-active' );

				} );

				aside.classList.remove( 'is-active' );

			}

		}
		/**
		 * Close Tabs on Form Submission
		 *
		 * @return {void}
		 */
		document.addEventListener('wpcf7mailsent', function closeTabsOnMailSent() {

			/* Transition
			 * @return {void}
			 */
			setTimeout( () => {

				closeTabs();

			}, 3000 );

		}, false );

	}

}
